import * as React from 'react';
import { PersonaSize, TooltipDelay, TooltipHost } from 'office-ui-fabric-react';
import { Resource, ResourceEntityState, ResourceStatus, StateInEntityInfo } from '../../../store/ResourcesListStore';
import { entityTypeLabelMap } from '../../../entities/common';
import { ImagePersonaCoin } from '../../common/ImagePersona';
import { ResourceName } from '../../views/list/columns/resource/Name';
import { StatusView } from '../../views/list/columns/resource/Status';
import { StateInEntityView } from '../../views/list/columns/resource/StateInEntity';
import { ResourceBookingType } from './ResourceUsageGrid';

type OwnProps = {
    resource: Resource;
    entityId?: string;
};

export const ResourcePlanResourceName = (props: OwnProps) => {
    const { resource, entityId } = props;
    const status = resource.attributes.Status;
    const stateInEntity = resource.stateInEntity;
    const isInactive = status === ResourceStatus.Inactive || stateInEntity?.state === ResourceEntityState.Inactive;
    const canView = resource.isEditable || resource.canView;

    return <TooltipHost
        tooltipProps={stateInEntity
            ? {
                onRenderContent: () => <StateTooltipContent resource={resource} entityId={entityId}
                    isInactive={isInactive} stateInEntity={stateInEntity} />,
                maxWidth: '464px',
                styles: { root: { width: '100%' } }
            }
            : undefined}
        closeDelay={10}
        delay={TooltipDelay.long}>
        <ResourceName name={resource.name} imageId={resource.imageId} href={`/resource/${resource.id}`} warnings={resource.warnings}
            canView={canView} isInactive={isInactive} />
    </TooltipHost>;
}

const StateTooltipContent = (props: { resource: Resource, entityId?: string, isInactive: boolean, stateInEntity: StateInEntityInfo }) => {
    const { resource, entityId, isInactive, stateInEntity } = props;
    const status = resource.attributes.Status;
    return <div className="timeline-tooltip">
        <div className="header">
            <span className={isInactive ? 'inactive-persona' : undefined}>
                <ImagePersonaCoin className="logo" size={PersonaSize.size32} info={resource} text={resource.name} />
                {isInactive && <span className="inactive-icon" />}
            </span>
            <div className="title">
                <div className="overflow-text" title={resource.name}>{resource.name}</div>
            </div>
            {!!entityId && <ResourceBookingType resource={resource} entityId={entityId} />}
        </div>
        <div className="content">
            {status !== undefined && <div className="item align-center">
                <div className="label">State</div>
                <StatusView status={status} />
            </div>}
            {stateInEntity.state !== undefined && <div className="item align-center">
                <div className="label">{`State in ${entityTypeLabelMap[stateInEntity.entityType].singular}`}</div>
                <StateInEntityView state={stateInEntity.state} />
            </div>}
        </div>
    </div>;
}
